import keysToConstants from 'js/lib/keysToConstants';

export default keysToConstants([
  'ELIGIBLE',
  'PROMOTION_INACTIVE',
  'PROMOTION_TOTAL_REDEMPTION_LIMIT_REACHED',
  'PRODUCT_NOT_ELIGIBLE',
  'PROMOTION_USER_REDEMPTION_LIMIT_REACHED',
  'NOT_ELIGIBLE_FOR_NEW_PAID_LEARNER_PROMOTION',
  // This is a hardcoded error when the promotion cannot be applied but not errorCode back from the BE
  'PROMOTION_CANNOT_BE_APPLIED',
  // Promo code-specific errors returned by PromotionEligibility endpoint
  'PROMO_CODE_NOT_FOUND',
  'PROMO_CODE_INACTIVE',
  'PROMO_CODE_REDEMPTION_LIMIT_REACHED',
]);
